import React from 'react';
export function SectionSeparator() {
  return <div className="w-full flex justify-center py-4 opacity-30" data-id="element-341">
      <div className="h-px w-full max-w-3xl bg-gradient-to-r from-transparent via-gold to-transparent" data-id="element-342" />
    </div>;
}